module.exports = __webpack_public_path__ + "static/Sonyax5d-fa209bbed05dce202e282b0b20f354a8.png";